import Scene from './Scene';
import common from '../common';
import {translate, Text} from '../utils';

export default class TutorialScene extends Scene {
	constructor() {
		super();
		this._pips = [];
		this._currentScreen = 0;
		this._spine = null;
		this._pages = 5;
	}

	init() {
		super.init();

		const bg = new PIXI.Sprite(P3.assets.texture('ui_bg_1'));
		bg.anchor.set(0.5);
		bg.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5));
		bg.width = 2000;
		this.addChild(bg);

		for (let i = 0; i < 4; i++) {
			const codetile = new PIXI.Sprite(P3.assets.texture('ui_bg_1_tile'));
			codetile.anchor.set(0, 0.5);
			codetile.position.set(-68 + (i * 450), (common.STAGE_HEIGHT * 0.5));
			this.addChild(codetile);
		}

		this._createVerticalLines(12);
		this._createHorizontalLines(4);

		const frameTop = new PIXI.Container();
		frameTop.rotation = 180 * PIXI.DEG_TO_RAD;
		this.addChild(frameTop);

		const frameTop1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop1.anchor.set(1, 0);
		frameTop.addChild(frameTop1);

		const frameTop2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop2.anchor.set(0, 0);
		frameTop.addChild(frameTop2);

		const frameBottom = new PIXI.Container();
		this.addChild(frameBottom);

		const frameBottom1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom1.anchor.set(1, 1);
		frameBottom.addChild(frameBottom1);

		const frameBottom2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom2.anchor.set(0, 1);
		frameBottom.addChild(frameBottom2);

		frameBottom.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT);
		frameTop.position.set((common.STAGE_WIDTH * 0.5), frameTop.height);

		const omnitrix = this._createOmnitrix();
		omnitrix.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5) + 30);
		this.addChild(omnitrix);

		this._spine = new PIXI.spine.Spine(P3.assets.spineData('tutorial'));
		this._spine.scale.set(0.5);
		this._spine.skeleton.setToSetupPose();
		this._spine.autoUpdate = false;
		this._spine.skeleton.setSkinByName(common.config.language);
		this._spine.position.set((common.STAGE_WIDTH * 0.5) + 1, (common.STAGE_HEIGHT * 0.5));
		this.addChild(this._spine);
		this._spine.state.setAnimation(0, `tutorial_1`, true);

		const states = new P3.ButtonStates();
		states.normal 	= P3.assets.texture('ui_btn_small_out');
		states.over 	= P3.assets.texture('ui_btn_small_over');
		states.down 	= P3.assets.texture('ui_btn_small_down');
		states.icon 	= P3.assets.texture('ui_icon_close');

		this.closeButton = new P3.Button(states);
		this.closeButton.clickSoundName = 'sfx_btn_press_00';
		this.closeButton.overSoundName = 'sfx_btn_rollover_00';
		this.closeButton.signals.click.add(() => {
			this.signals.previous.dispatch(this);
		}, this);

		this.addChild(this.closeButton);
	}

	_createHorizontalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));
			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 0.7);
			line.rotation = (P3.math.random(-5, 5) * PIXI.DEG_TO_RAD) + (90 * PIXI.DEG_TO_RAD);
			line.height = common.STAGE_WIDTH;
			line.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT / count) * i);
			this.addChild(line);

			// up-down anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					y: line.position.y + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	_createVerticalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));
			const angle = P3.math.random(-10, 10);

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 1);
			line.rotation = angle * PIXI.DEG_TO_RAD;
			line.height = common.STAGE_HEIGHT;
			line.position.set((common.STAGE_WIDTH / count) * i, (common.STAGE_HEIGHT * 0.5));
			this.addChild(line);

			// left-right anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					x: line.position.x + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	_createOmnitrix() {
		const container = new PIXI.Container();

		const deviceTop = new PIXI.Sprite(P3.assets.texture('ui_help_device_top'));
		deviceTop.anchor.set(0.5);
		deviceTop.position.set(0, -320);
		container.addChild(deviceTop);

		const pipBG = new PIXI.Sprite(P3.assets.texture('ui_help_device_bottom'));
		pipBG.anchor.set(0.5);
		pipBG.position.set(0, 290);
		container.addChild(pipBG);

		const titletext = Text(`// ${translate('MENU.TUTORIAL.TITLE')}`, {font: '64px ZCOOL QingKe HuangYou', align: 'center'});
		titletext.tint = 0xB3FF47;
		titletext.anchor.set(0.5);
		titletext.position.set(0, -10);
		deviceTop.addChild(titletext);

		const device = new PIXI.Sprite(P3.assets.texture('ui_help_device'));
		device.anchor.set(0.5);
		device.position.set(0, 0);
		container.addChild(device);

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_help_next_out');
		states.over = P3.assets.texture('ui_btn_help_next_over');
		states.down = P3.assets.texture('ui_btn_help_next_down');

		const rightButton = new P3.Button(states);
		rightButton.clickSoundName = 'sfx_btn_press_00';
		rightButton.overSoundName = 'sfx_btn_rollover_00';
		rightButton.signals.click.add(() => {
			this.nextPage();
		}, this);
		rightButton.position.set(460, 0);
		container.addChild(rightButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_help_next_out');
		states.over = P3.assets.texture('ui_btn_help_next_over');
		states.down = P3.assets.texture('ui_btn_help_next_down');

		const leftButton = new P3.Button(states);
		leftButton.clickSoundName = 'sfx_btn_press_00';
		leftButton.overSoundName = 'sfx_btn_rollover_00';
		leftButton.signals.click.add(() => {
			this.prevPage();
		}, this);
		leftButton.scale.x = -1;
		leftButton.position.set(-460, 0);
		container.addChild(leftButton);

		for (let i = 0; i < this._pages; i++) {
			const pip = new PIXI.Sprite(P3.assets.texture('ui_help_device_pagination_off'));
			pip.anchor.set(0.5);
			pip.position.set((((pipBG.width - 60) / this._pages) * i) - (pipBG.width * 0.5) + 50, 15);
			pipBG.addChild(pip);
			this._pips.push(pip);

			if (i === 0) {
				pip.texture = P3.assets.texture('ui_help_device_pagination_on');
			}
		}

		this.tutorialText = Text(translate('MENU.TUTORIAL.SCREEN1'), {font: '32px Ahkio Thin', align: 'center'});
		this.tutorialText.tint = 0xFFFFFF;
		this.tutorialText.maxWidth = 650;
		this.tutorialText.anchor.set(0.5);
		this.tutorialText.position.set(0, 190);
		container.addChild(this.tutorialText);

		return container;
	}

	nextPage() {
		if (this._currentScreen >= this._pages - 1) {
			return;
		}

		this._pips[this._currentScreen].texture = P3.assets.texture('ui_help_device_pagination_off');
		++this._currentScreen;
		this._pips[this._currentScreen].texture = P3.assets.texture('ui_help_device_pagination_on');
		this._spine.state.setAnimation(0, `tutorial_${this._currentScreen + 1}`, true);
		this.tutorialText.text = translate(`MENU.TUTORIAL.SCREEN${this._currentScreen + 1}`);
	}

	prevPage() {
		if (this._currentScreen <= 0) {
			return;
		}

		this._pips[this._currentScreen].texture = P3.assets.texture('ui_help_device_pagination_off');
		--this._currentScreen;
		this._pips[this._currentScreen].texture = P3.assets.texture('ui_help_device_pagination_on');
		this._spine.state.setAnimation(0, `tutorial_${this._currentScreen + 1}`, true);
		this.tutorialText.text = translate(`MENU.TUTORIAL.SCREEN${this._currentScreen + 1}`);
	}
	destroy() {
		super.destroy();
	}

	update() {
		super.update();
		this._spine.update(P3.Ticker.dt);
	}

	resize() {
		super.resize();

		this.closeButton.position.set(((common.STAGE_WIDTH + P3.View.width) * 0.5) - 75, 75);
	}
}
